import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from "react";
import { Animated, Platform, View, ScrollView } from "react-native";
import FadeLoader from "../Spinners/FadeSpinner/FadeSpinner";
//import InteractionManager from '../InteractionManager.js';
import dismissKeyboard from "../DismissKeyboard.js";
import moment from "moment";
import PnmacInputToolbar from "../InputToolbar";
import PnmacMessageContainer from "../MessageContainer";
import PropTypes from "prop-types";
import styles from "./PnmacMacChat.styles.js";
var MIN_COMPOSER_HEIGHT = Platform.select({
  ios: 33,
  android: 41,
  web: 50
});
var MIN_INPUT_TOOLBAR_HEIGHT = 50;
var PnmacMacChat = /** @class */function (_super) {
  __extends(PnmacMacChat, _super);
  function PnmacMacChat(props) {
    var _this = _super.call(this, props) || this;
    _this.setChatState = function (newState) {
      _this.setState(newState, _this.changeChatBusyStatus());
    };
    _this.initLocale = function () {
      if (_this.props.locale === null || moment.locales().indexOf(_this.props.locale) === -1) {
        _this.setLocale("en");
      } else {
        _this.setLocale(_this.props.locale);
      }
    };
    _this.initMessages = function (messages) {
      if (messages === void 0) {
        messages = [];
      }
      _this.setMessages(messages);
    };
    _this.setLocale = function (locale) {
      _this._locale = locale;
    };
    _this.getLocale = function () {
      return _this._locale;
    };
    _this.setMessages = function (messages) {
      _this._messages = messages;
    };
    _this.getMessages = function () {
      return _this._messages;
    };
    _this.setMaxHeight = function (height) {
      _this._maxHeight = height;
    };
    _this.getMaxHeight = function () {
      return _this._maxHeight;
    };
    _this.setKeyboardHeight = function (height) {
      _this._keyboardHeight = height;
    };
    _this.getKeyboardHeight = function () {
      return _this._keyboardHeight;
    };
    _this.setBottomOffset = function (value) {
      _this._bottomOffset = value;
    };
    _this.getBottomOffset = function () {
      return _this._bottomOffset;
    };
    _this.setIsFirstLayout = function (value) {
      _this._isFirstLayout = value;
    };
    _this.getIsFirstLayout = function () {
      return _this._isFirstLayout;
    };
    _this.setIsTypingDisabled = function (value) {
      _this.setState({
        typingDisabled: value
      });
    };
    _this.getIsTypingDisabled = function () {
      return _this.state.typingDisabled;
    };
    _this.setIsMounted = function (value) {
      _this._isMounted = value;
    };
    _this.getIsMounted = function () {
      return _this._isMounted;
    };
    // TODO
    // setMinInputToolbarHeight
    _this.getMinInputToolbarHeight = function () {
      if (_this.props.renderAccessory) {
        return MIN_INPUT_TOOLBAR_HEIGHT * 2;
      }
      return MIN_INPUT_TOOLBAR_HEIGHT;
    };
    _this.prepareMessagesContainerHeight = function (value) {
      if (_this.props.isAnimated === true) {
        return new Animated.Value(value);
      }
      return value;
    };
    _this.onKeyboardWillShow = function (e) {
      _this.setIsTypingDisabled(true);
      _this.setKeyboardHeight(e.endCoordinates ? e.endCoordinates.height : e.end.height);
      _this.setBottomOffset(_this.props.bottomOffset);
      var newMessagesContainerHeight = _this.getMaxHeight() - (_this.state.composerHeight + (_this.getMinInputToolbarHeight() - MIN_COMPOSER_HEIGHT)) - _this.getKeyboardHeight() + _this.getBottomOffset();
      if (_this.props.isAnimated === true) {
        Animated.timing(_this.state.messagesContainerHeight, {
          toValue: newMessagesContainerHeight,
          duration: 210
        }).start();
      } else {
        _this.setState({
          messagesContainerHeight: newMessagesContainerHeight
        });
      }
    };
    _this.onKeyboardWillHide = function () {
      _this.setIsTypingDisabled(true);
      _this.setKeyboardHeight(0);
      _this.setBottomOffset(0);
      var newMessagesContainerHeight = _this.getMaxHeight() - (_this.state.composerHeight + (_this.getMinInputToolbarHeight() - MIN_COMPOSER_HEIGHT));
      if (_this.props.isAnimated === true) {
        Animated.timing(_this.state.messagesContainerHeight, {
          toValue: newMessagesContainerHeight,
          duration: 210
        }).start();
      } else {
        _this.setState({
          messagesContainerHeight: newMessagesContainerHeight
        });
      }
    };
    _this.onKeyboardDidShow = function (e) {
      if (Platform.OS === "android") {
        _this.onKeyboardWillShow(e);
      }
      _this.setIsTypingDisabled(false);
    };
    _this.onKeyboardDidHide = function (e) {
      if (Platform.OS === "android") {
        _this.onKeyboardWillHide(e);
      }
      _this.setIsTypingDisabled(false);
    };
    // scrollToBottom = (animated = true) => {
    //   if(this.scrollViewRef)
    //     this.scrollViewRef.current.scrollToEnd({animated: true})
    // };
    _this.onTouchStart = function () {
      _this._touchStarted = true;
    };
    _this.onTouchMove = function () {
      _this._touchStarted = false;
    };
    // handle Tap event to dismiss keyboard
    _this.onTouchEnd = function () {
      if (_this._touchStarted === true) {
        dismissKeyboard();
      }
      _this._touchStarted = false;
    };
    _this.renderMessages = function () {
      var AnimatedView = _this.props.isAnimated === true ? Animated.View : View;
      return /*#__PURE__*/React.createElement(ScrollView, {
        showsHorizontalScrollIndicator: false,
        // ref={this.scrollViewRef}
        style: {
          maxHeight: "100%",
          backgroundColor: "white"
        },
        onContentSizeChange: function () {
          // if(this.scrollViewRef && this.scrollViewRef.scrollToBottom){
          //   this.scrollViewRef.scrollToBottom({ animated: true });
          // }
        }
      }, /*#__PURE__*/React.createElement(AnimatedView, {
        style: {
          height: _this.state.messagesContainerHeight
        }
      }, /*#__PURE__*/React.createElement(PnmacMessageContainer, __assign({}, _this.props, {
        macResponse: function (d) {
          return _this.onSend([{
            text: d,
            user: {
              _id: 1
            },
            createdAt: new Date(),
            _id: "temp-id-68305"
          }]);
        },
        invertibleScrollViewProps: _this.invertibleScrollViewProps,
        messages: _this.getMessages()
      })), _this.renderChatFooter()));
    };
    _this.getChatNewStatus = function () {
      if (_this.props.liveAgentIsLoading) {
        return "isBusy";
      }
      if (!_this.props.isInitialized) {
        return "isBusy";
      } else if (_this.props.isBlocked) {
        return "blockSession";
      } else if (_this.props.isSpeakerOn && _this.props.isSpeaking) {
        return "isSpeaking";
      } else if (_this.props.isMicOn && _this.props.isListening) {
        return "isListening";
      } else if (_this.props.isMicOn) {
        return "isWaitingForMicInput";
      } else if (_this.props.isBusy) {
        return "isBusy";
      } else {
        return "isReady";
      }
    };
    _this.changeChatBusyStatus = function (newStatus) {
      newStatus = newStatus || _this.getChatNewStatus();
      _this.setState({
        chatBusyState: newStatus
      });
    };
    _this.onSend = function (messages, shouldResetInputToolbar) {
      if (messages === void 0) {
        messages = [];
      }
      if (shouldResetInputToolbar === void 0) {
        shouldResetInputToolbar = false;
      }
      return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
          if (this.props.isBlocked) return [2 /*return*/, true];
          if (this.state.chatBusyState != 'isBusy') {
            this.setState({
              chatBusyState: "isBusy"
            }, function () {
              if (!Array.isArray(messages)) {
                messages = [messages];
              }
              messages = messages.map(function (message) {
                return __assign(__assign({}, message), {
                  user: _this.props.user,
                  createdAt: new Date(),
                  _id: "temp-id-" + Math.round(Math.random() * 1000000)
                });
              });
              if (shouldResetInputToolbar === true) {
                _this.setIsTypingDisabled(true);
                _this.resetInputToolbar();
              }
              _this.props.onSend(messages, _this.changeChatBusyStatus);
              if (shouldResetInputToolbar === true) {
                setTimeout(function () {
                  if (_this.getIsMounted() === true) {
                    _this.setIsTypingDisabled(false);
                  }
                }, 100);
              }
            });
          }
          return [2 /*return*/];
        });
      });
    };
    _this.resetInputToolbar = function () {
      if (_this.textInput) {
        _this.textInput.clear();
      }
      _this.setState({
        text: "",
        composerHeight: MIN_COMPOSER_HEIGHT,
        messagesContainerHeight: _this.prepareMessagesContainerHeight(_this.getMaxHeight() - _this.getMinInputToolbarHeight() - _this.getKeyboardHeight() + _this.props.bottomOffset)
      });
    };
    _this.calculateInputToolbarHeight = function (newComposerHeight) {
      return newComposerHeight + (_this.getMinInputToolbarHeight() - MIN_COMPOSER_HEIGHT);
    };
    _this.onInputSizeChanged = function (size) {
      var newComposerHeight = MIN_COMPOSER_HEIGHT; //Math.max(MIN_COMPOSER_HEIGHT, Math.min(MAX_COMPOSER_HEIGHT, size.height));
      var newMessagesContainerHeight = _this.getMaxHeight() - _this.calculateInputToolbarHeight(newComposerHeight) - _this.getKeyboardHeight() + _this.getBottomOffset();
      _this.setState({
        composerHeight: newComposerHeight,
        messagesContainerHeight: _this.prepareMessagesContainerHeight(newMessagesContainerHeight)
      });
    };
    _this.onInputTextChanged = function (text) {
      if (_this.getIsTypingDisabled()) {
        return;
      }
      _this.setState({
        text: text
      });
    };
    _this.onInitialLayoutViewLayout = function (e) {
      var layout = e.nativeEvent.layout;
      if (layout.height <= 0) {
        return;
      }
      _this.setMaxHeight(layout.height);
      //InteractionManager.runAfterInteractions(() => {
      _this.setState({
        isInitialized: _this.props.isInitialized,
        text: "",
        composerHeight: MIN_COMPOSER_HEIGHT,
        messagesContainerHeight: _this.prepareMessagesContainerHeight(_this.getMaxHeight() - _this.getMinInputToolbarHeight())
      });
      _this.changeChatBusyStatus();
      //});
    };
    _this.onMainViewLayout = function (e) {
      if (Platform.OS === "android") {
        // fix an issue when keyboard is dismissing during the initialization
        var layout = e.nativeEvent.layout;
        if (_this.getMaxHeight() !== layout.height && _this.getIsFirstLayout() === true) {
          _this.setMaxHeight(layout.height);
          _this.setState({
            messagesContainerHeight: _this.prepareMessagesContainerHeight(_this.getMaxHeight() - _this.getMinInputToolbarHeight())
          });
        }
      }
      if (_this.getIsFirstLayout() === true) {
        _this.setIsFirstLayout(false);
      }
    };
    _this.resetChatState = function () {
      _this.setState({
        chatBusyState: "isReady"
      });
    };
    _this.renderInputToolbar = function () {
      var inputToolbarProps = __assign(__assign({}, _this.props), {
        text: _this.state.text,
        noOutLineOnFocus: true,
        chatBusyState: _this.state.chatBusyState,
        isBlocked: _this.props.isBlocked,
        //composerHeight: Math.max(MIN_COMPOSER_HEIGHT, this.state.composerHeight),
        onSend: _this.onSend,
        onInputSizeChanged: _this.onInputSizeChanged,
        onTextChanged: _this.onInputTextChanged,
        resetChatState: _this.resetChatState,
        textInputProps: __assign(__assign({}, _this.props.textInputProps), {
          ref: function (textInput) {
            return _this.textInput = textInput;
          },
          maxLength: _this.getIsTypingDisabled() ? 0 : _this.props.maxLength
        })
      });
      if (_this.getIsTypingDisabled()) {
        inputToolbarProps.textInputProps.maxLength = 0;
      }
      if (_this.props.renderInputToolbar) {
        return _this.props.renderInputToolbar(inputToolbarProps);
      }
      return /*#__PURE__*/React.createElement(PnmacInputToolbar, __assign({}, inputToolbarProps));
    };
    _this.renderChatFooter = function () {
      if (_this.props.renderChatFooter) {
        var footerProps = __assign({}, _this.props);
        return _this.props.renderChatFooter(footerProps);
      }
      return null;
    };
    _this.renderLoading = function () {
      if (_this.props.renderLoading) {
        return _this.props.renderLoading();
      }
      return null;
    };
    // default values
    _this._isMounted = false;
    _this._keyboardHeight = 0;
    _this._bottomOffset = 0;
    _this._maxHeight = null;
    _this._touchStarted = false;
    _this._isFirstLayout = true;
    _this._locale = "en";
    _this._messages = [];
    _this.state = {
      composerHeight: MIN_COMPOSER_HEIGHT,
      messagesContainerHeight: null,
      typingDisabled: false,
      chatBusyState: _this.getChatNewStatus()
    };
    _this.invertibleScrollViewProps = {
      inverted: true,
      keyboardShouldPersistTaps: true,
      onTouchStart: _this.onTouchStart,
      onTouchMove: _this.onTouchMove,
      onTouchEnd: _this.onTouchEnd,
      onKeyboardWillShow: _this.onKeyboardWillShow,
      onKeyboardWillHide: _this.onKeyboardWillHide,
      onKeyboardDidShow: _this.onKeyboardDidShow,
      onKeyboardDidHide: _this.onKeyboardDidHide
    };
    return _this;
    // this.scrollViewRef = React.createRef();
  }
  PnmacMacChat.append = function (currentMessages, messages) {
    if (currentMessages === void 0) {
      currentMessages = [];
    }
    if (!Array.isArray(messages)) {
      messages = [messages];
    }
    return messages.concat(currentMessages);
  };
  PnmacMacChat.prepend = function (currentMessages, messages) {
    if (currentMessages === void 0) {
      currentMessages = [];
    }
    if (!Array.isArray(messages)) {
      messages = [messages];
    }
    return currentMessages.concat(messages);
  };
  PnmacMacChat.prototype.getChildContext = function () {
    var _this = this;
    return {
      actionSheet: function () {
        return _this._actionSheetRef;
      },
      getLocale: this.getLocale
    };
  };
  PnmacMacChat.prototype.componentDidMount = function () {};
  PnmacMacChat.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.transferToLiveAgent !== this.props.transferToLiveAgent && !this.props.transferToLiveAgent) {
      this.resetInputToolbar();
    }
  };
  PnmacMacChat.prototype.componentWillMount = function () {
    this.setIsMounted(true);
    this.initLocale();
    this.initMessages(this.props.messages);
  };
  PnmacMacChat.prototype.componentWillUnmount = function () {
    this.setIsMounted(false);
  };
  PnmacMacChat.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps === void 0) {
      nextProps = {};
    }
    this.initMessages(nextProps.messages);
    // this.scrollToBottom();
  };
  PnmacMacChat.prototype.render = function () {
    if (this.state.isInitialized === true) {
      return /*#__PURE__*/React.createElement(View, {
        style: styles.container,
        onLayout: this.onMainViewLayout,
        testID: "chat"
      }, this.renderMessages(), this.renderInputToolbar());
    }
    return /*#__PURE__*/React.createElement(View, {
      style: styles.containerNotReady,
      onLayout: this.onInitialLayoutViewLayout,
      testID: "chat"
    }, /*#__PURE__*/React.createElement(FadeLoader, {
      height: 15,
      width: 5,
      radius: 2,
      margin: 2,
      color: this.props.loadingColor || "#00489D"
    }));
  };
  return PnmacMacChat;
}(React.Component);
PnmacMacChat.childContextTypes = {
  actionSheet: PropTypes.func,
  getLocale: PropTypes.func
};
PnmacMacChat.defaultProps = {
  messages: [],
  onSend: function () {},
  loadEarlier: false,
  onLoadEarlier: function () {},
  locale: null,
  isAnimated: Platform.select({
    ios: true,
    android: false
  }),
  renderAccessory: null,
  renderActions: null,
  renderAvatar: null,
  renderBubble: null,
  renderFooter: null,
  renderChatFooter: null,
  renderMessageText: null,
  renderMessageImage: null,
  renderComposer: null,
  renderCustomView: null,
  renderDay: null,
  renderInputToolbar: null,
  renderLoadEarlier: null,
  renderLoading: null,
  renderMessage: null,
  renderSend: null,
  renderTime: null,
  user: {},
  bottomOffset: 0,
  isLoadingEarlier: false
};
PnmacMacChat.propTypes = {
  messages: PropTypes.array,
  onSend: PropTypes.func,
  loadEarlier: PropTypes.bool,
  onLoadEarlier: PropTypes.func,
  locale: PropTypes.string,
  isAnimated: PropTypes.bool,
  renderAccessory: PropTypes.func,
  renderActions: PropTypes.func,
  renderAvatar: PropTypes.func,
  renderBubble: PropTypes.func,
  renderFooter: PropTypes.func,
  renderChatFooter: PropTypes.func,
  renderMessageText: PropTypes.func,
  renderMessageImage: PropTypes.func,
  renderComposer: PropTypes.func,
  renderCustomView: PropTypes.func,
  renderDay: PropTypes.func,
  renderInputToolbar: PropTypes.func,
  renderLoadEarlier: PropTypes.func,
  renderLoading: PropTypes.func,
  renderMessage: PropTypes.func,
  renderSend: PropTypes.func,
  renderTime: PropTypes.func,
  user: PropTypes.object,
  bottomOffset: PropTypes.number,
  isLoadingEarlier: PropTypes.bool
};
export default PnmacMacChat;